import script from "./ChannelsListItem.vue?vue&type=script&setup=true&lang=js"
export * from "./ChannelsListItem.vue?vue&type=script&setup=true&lang=js"

import "./ChannelsListItem.vue?vue&type=style&index=0&id=90aec960&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-90aec960"]])

export default __exports__